import { requestGet, requestPost } from '@/common/request';

export default {
  // 查询banner列表
  async bannerList(query) {
    return await requestGet('/banner/list', query);
  },
  // 删除banner
  async bannerDelete(query) {
    return await requestGet('/banner/delete', query);
  },
  // 更新banner启用状态
  async bannerModifyStatus(query) {
    return await requestGet('/banner/modifyStatus', query);
  },
  // 新增banner
  async bannerCreate(query) {
    return await requestPost('/banner/create', query);
  },
  // 查询banner信息
  async bannerGetById(query) {
    return await requestGet('/banner/getById', query);
  },
  // 更新banner信息
  async bannerUpdate(query) {
    return await requestPost('/banner/update', query);
  },
  // banner管理 - 跳转链接校验
  async bannerJumpUrlValidate(query) {
    return await requestGet('/banner/jumpUrlValidate', query);
  },
  // 获取会场活动和综促活动
  async queryActivityBannerInfo(query) {
    return await requestGet('/generic/mac/activity/queryActivityBannerInfoByName', query);
  },
  async genericActivityDetailV2(query) {
    return await requestGet('/generic/mac/activity/detailV2', query);
  },
};
